/**
 * @description localstorage processing
 * @source  https://github.com/steamerjs/steamer-browserutils
 */
/**
 * 判断value的类型
 * javascript 1.8.5之后toString.call已经支持ok了。不需要再对null, undefined做特殊处理了
 * @param type     type的类型：  Null | Undefined | Array | Object etc
 * @param value
 * @returns
 */
export function isType(type, value) {
    return Object.prototype.toString.call(value) === "[object ".concat(type, "]");
}
export function isBoolean(value) {
    return isType('Boolean', value);
}
export function isNumber(value) {
    return isType('Number', value);
}
export function isString(value) {
    return isType('String', value);
}
export function isFunction(value) {
    return isType('Function', value);
}
export function isArray(value) {
    return isType('Array', value);
}
export function isDate(value) {
    return isType('Date', value);
}
export function isRegExp(value) {
    return isType('RegExp', value);
}
export function isObject(value) {
    return isType('Object', value);
}
export function isError(value) {
    return isType('Error', value);
}
